import { render, staticRenderFns } from "./UserProfileFacilities.vue?vue&type=template&id=340675f0"
import script from "./UserProfileFacilities.vue?vue&type=script&lang=js"
export * from "./UserProfileFacilities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports